// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"679":"eb3ac9bd","963":"3adca180"}[chunkId] + ".css";
};